import { render, staticRenderFns } from "./bodyImg.vue?vue&type=template&id=97247900"
import script from "./bodyImg.vue?vue&type=script&lang=js"
export * from "./bodyImg.vue?vue&type=script&lang=js"
import style0 from "./bodyImg.vue?vue&type=style&index=0&id=97247900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports